<template>
  <h1>RFID Towel Folding</h1>
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="content-section">

        <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-xsm btn btn-rfid btn-associate btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              ></FormKit>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="row mt-5">
          <div class="alert alert-danger" v-if="error_message">
              <div v-html="error_message"></div>
            </div>
         <FormKit
                ref="serviceTicketInput"
                v-model="serviceTicketCode"
                type="text"
                name="serviceTicketCode"
                id="serviceTicketCode"
                label="Scan a RFID Laundry service ticket"
                placeholder="Service Ticket Code"
                validation="required"
                aria-autocomplete="none"
                autocomplete="off"
            />
        </div>
      </div>



    </div>
  </div>
</template>


<script setup>

import {onMounted, ref, watch, inject, reactive, nextTick} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import ServiceTicket from '@/services/ServiceTicketService.js';
import { barcodePatterns } from '@/utils/orderUtils';
import { get } from 'lodash';

const serviceTicketCode = ref('');
const error_message = ref('');
// key used to force re-render/reset the FormKit input
const inputClearedKey = ref(0);
const serviceTicketInput = ref(null);

const forceRenderInput = () => {
  inputClearedKey.value += 1;
};

const getBarcodeDetails = (barcode) => {
  let barcode_type;
  let barcode_id;
  for( let type in barcodePatterns ) {
    let matchResult = barcode.match( barcodePatterns[type] );
    if( matchResult ) {
      barcode_type  = type;
      barcode_id    = matchResult[1] || barcode;
      break;
    }
  }
  let barcode_details ={ type: barcode_type, id: barcode_id, barcode: barcode };

  return barcode_details;
};
const clearInputAndShowError = (message) => {
  error_message.value = message;
  // Use nextTick to ensure the error message renders before we clear the input,
  // which might trigger another watch cycle.
  nextTick(() => {
    serviceTicketCode.value = '';
  });
};
watch(() => serviceTicketCode.value, (newValue) => {
  if (!newValue || newValue.length === 0) {
    error_message.value = ''; // Clear error when input is empty
    return;
  }
  let barcodeDetails = getBarcodeDetails(serviceTicketCode.value);
  if (barcodeDetails.type !== "ticket" && barcodeDetails.type !== "ticket_order") {
      // Do nothing yet, wait for the full code to be scanned.
      // Or if you expect it to be valid immediately, show an error.
      return;
    }
    // Assuming the full code is entered at once
    if (!barcodeDetails.id) {
      clearInputAndShowError("Invalid Service Ticket barcode: " + newValue);
      return;
    }
    getServiceTicketOrder(newValue);
});
const getServiceTicketOrder = async (barcode) => {
  try {
    const defaultServiceId = process.env.VUE_APP_DEFAULT_SERVICE_TYPE_ID || 1;
    const response = await ServiceTicket.getOrderByBarcode(barcode, defaultServiceId);
    const ticketDetails = response.data.data.service_ticket;

    if (ticketDetails.order_id) {
      const [serviceTicketID, checkCode] = barcode.split("/");
      window.open(`/rfid/folding-ticket/${serviceTicketID}/${checkCode}`, "_self");
    } else {
      clearInputAndShowError(response.data.message || "Service Ticket not found: " + barcode);
    }
  } catch (error) {
    console.error("Error loading order details:", error);
    const message = error.response?.data?.message || "Error: Invalid/Outdated Service Ticket";
    clearInputAndShowError(message);
  }
};

const goTo = (pageSection) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/dashboard",
          "_self"
      );
      break;
    default:
      console.error("Unknown page section: " + pageSection);
      break;
  }
}
onMounted(() => {
  // Clear the value on mount
  serviceTicketCode.value = '';

   // Use a slightly longer timeout to ensure this runs *after* the sidebar's focus logic.
  setTimeout(() => {
    // First, forcefully remove focus from whatever element currently has it.
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }

    // Now, find our target input.
    const inputEl = document.getElementById('serviceTicketCode');

    // If found, set focus to it.
    if (inputEl && typeof inputEl.focus === 'function') {
      inputEl.focus();
      console.log("Successfully forced focus to the service ticket input.");
    } else {
      console.error("Could not find the input element to focus after mount.");
    }
  }, 250); // Increased delay to 250ms to reliably win the focus race.
});

</script>


<style scoped>

.main-section > h1:first-child {
  background: var(--bundling-bg-color);
}
</style>
